import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _createFulfillmentMethodRequest = {
    fulfillmentMethod: '_fulfillmentMethod',
};
var _createFulfillmentMethodResponse = {
    fulfillmentMethod: '_fulfillmentMethod',
};
var _customDetails = { geocodes: '_addressLocation' };
var _deleteFulfillmentMethodRequest = {};
var _deleteFulfillmentMethodResponse = {};
var _deliveryInfo = { restaurant: '_restaurant' };
var _deliveryRange = {
    radiusDetails: '_radiusDetails',
    customDetails: '_customDetails',
};
var _findBestDeliveryAreaRequest = {
    deliveryTime: 'google.protobuf.Timestamp',
    geocode: '_addressLocation',
};
var _findBestDeliveryAreaResponse = { deliveryInfo: '_deliveryInfo' };
var _fulfillmentMethod = { deliveryInfo: '_deliveryInfo' };
var _getFulfillmentMethodRequest = {};
var _getFulfillmentMethodResponse = {
    fulfillmentMethod: '_fulfillmentMethod',
};
var _listFulfillmentMethodsRequest = {};
var _listFulfillmentMethodsResponse = {
    fulfillmentMethods: '_fulfillmentMethod',
};
var _radiusDetails = { geocode: '_addressLocation' };
var _restaurant = { deliveryRange: '_deliveryRange' };
var _updateFulfillmentMethodRequest = {
    mask: 'google.protobuf.FieldMask',
    fulfillmentMethod: '_fulfillmentMethod',
};
var _updateFulfillmentMethodResponse = {
    fulfillmentMethod: '_fulfillmentMethod',
};
function resolveComWixpressRestaurantsFulfillmentsV3FulfillmentMethodsUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/v3/fulfillment-methods',
                destPath: '/v3/fulfillment-methods',
            },
        ],
        _: [
            {
                srcPath: '/_api/fulfillment-methods',
                destPath: '/v3/fulfillment-methods',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/fulfillment-methods',
                destPath: '/v3/fulfillment-methods',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/fulfillment-methods',
                destPath: '/v3/fulfillment-methods',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new FulfillmentMethod */
export function createFulfillmentMethod(payload) {
    var _a = serializer(_createFulfillmentMethodRequest, {
        _addressLocation: _addressLocation,
        _customDetails: _customDetails,
        _deliveryInfo: _deliveryInfo,
        _deliveryRange: _deliveryRange,
        _fulfillmentMethod: _fulfillmentMethod,
        _radiusDetails: _radiusDetails,
        _restaurant: _restaurant,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFulfillmentMethodResponse, {
        _addressLocation: _addressLocation,
        _customDetails: _customDetails,
        _deliveryInfo: _deliveryInfo,
        _deliveryRange: _deliveryRange,
        _fulfillmentMethod: _fulfillmentMethod,
        _radiusDetails: _radiusDetails,
        _restaurant: _restaurant,
    }).fromJSON;
    function __createFulfillmentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.fulfillments.v3.fulfillment_method',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.fulfillments.v3.FulfillmentMethods.CreateFulfillmentMethod',
            url: resolveComWixpressRestaurantsFulfillmentsV3FulfillmentMethodsUrl({
                protoPath: '/v3/fulfillment-methods',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFulfillmentMethod.fromReq = fromReq;
    __createFulfillmentMethod.__isAmbassador = true;
    return __createFulfillmentMethod;
}
/** Get a FulfillmentMethod by id */
export function getFulfillmentMethod(payload) {
    var _a = serializer(_getFulfillmentMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFulfillmentMethodResponse, {
        _addressLocation: _addressLocation,
        _customDetails: _customDetails,
        _deliveryInfo: _deliveryInfo,
        _deliveryRange: _deliveryRange,
        _fulfillmentMethod: _fulfillmentMethod,
        _radiusDetails: _radiusDetails,
        _restaurant: _restaurant,
    }).fromJSON;
    function __getFulfillmentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.fulfillments.v3.fulfillment_method',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.fulfillments.v3.FulfillmentMethods.GetFulfillmentMethod',
            url: resolveComWixpressRestaurantsFulfillmentsV3FulfillmentMethodsUrl({
                protoPath: '/v3/fulfillment-methods/{fulfillmentMethodId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFulfillmentMethod.fromReq = fromReq;
    __getFulfillmentMethod.__isAmbassador = true;
    return __getFulfillmentMethod;
}
/** Update a FulfillmentMethod, supports partial update */
export function updateFulfillmentMethod(payload) {
    var _a = serializer(_updateFulfillmentMethodRequest, {
        _addressLocation: _addressLocation,
        _customDetails: _customDetails,
        _deliveryInfo: _deliveryInfo,
        _deliveryRange: _deliveryRange,
        _fulfillmentMethod: _fulfillmentMethod,
        _radiusDetails: _radiusDetails,
        _restaurant: _restaurant,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateFulfillmentMethodResponse, {
        _addressLocation: _addressLocation,
        _customDetails: _customDetails,
        _deliveryInfo: _deliveryInfo,
        _deliveryRange: _deliveryRange,
        _fulfillmentMethod: _fulfillmentMethod,
        _radiusDetails: _radiusDetails,
        _restaurant: _restaurant,
    }).fromJSON;
    function __updateFulfillmentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.fulfillments.v3.fulfillment_method',
            method: 'PATCH',
            methodFqn: 'com.wixpress.restaurants.fulfillments.v3.FulfillmentMethods.UpdateFulfillmentMethod',
            url: resolveComWixpressRestaurantsFulfillmentsV3FulfillmentMethodsUrl({
                protoPath: '/v3/fulfillment-methods/{fulfillmentMethod.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateFulfillmentMethod.fromReq = fromReq;
    __updateFulfillmentMethod.__isAmbassador = true;
    return __updateFulfillmentMethod;
}
/** Delete a FulfillmentMethod */
export function deleteFulfillmentMethod(payload) {
    var _a = serializer(_deleteFulfillmentMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteFulfillmentMethodResponse, {}).fromJSON;
    function __deleteFulfillmentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.fulfillments.v3.fulfillment_method',
            method: 'DELETE',
            methodFqn: 'com.wixpress.restaurants.fulfillments.v3.FulfillmentMethods.DeleteFulfillmentMethod',
            url: resolveComWixpressRestaurantsFulfillmentsV3FulfillmentMethodsUrl({
                protoPath: '/v3/fulfillment-methods/{fulfillmentMethodId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteFulfillmentMethod.fromReq = fromReq;
    __deleteFulfillmentMethod.__isAmbassador = true;
    return __deleteFulfillmentMethod;
}
/** List Fulfillment Methods */
export function listFulfillmentMethods(payload) {
    var _a = serializer(_listFulfillmentMethodsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFulfillmentMethodsResponse, {
        _addressLocation: _addressLocation,
        _customDetails: _customDetails,
        _deliveryInfo: _deliveryInfo,
        _deliveryRange: _deliveryRange,
        _fulfillmentMethod: _fulfillmentMethod,
        _radiusDetails: _radiusDetails,
        _restaurant: _restaurant,
    }).fromJSON;
    function __listFulfillmentMethods(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.fulfillments.v3.fulfillment_method',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.fulfillments.v3.FulfillmentMethods.ListFulfillmentMethods',
            url: resolveComWixpressRestaurantsFulfillmentsV3FulfillmentMethodsUrl({
                protoPath: '/v3/fulfillment-methods',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFulfillmentMethods.fromReq = fromReq;
    __listFulfillmentMethods.__isAmbassador = true;
    return __listFulfillmentMethods;
}
/** Find the best delivery area for a geocoded order address */
export function findBestDeliveryArea(payload) {
    var _a = serializer(_findBestDeliveryAreaRequest, { _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_findBestDeliveryAreaResponse, {
        _addressLocation: _addressLocation,
        _customDetails: _customDetails,
        _deliveryInfo: _deliveryInfo,
        _deliveryRange: _deliveryRange,
        _radiusDetails: _radiusDetails,
        _restaurant: _restaurant,
    }).fromJSON;
    function __findBestDeliveryArea(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.fulfillments.v3.fulfillment_method',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.fulfillments.v3.FulfillmentMethods.FindBestDeliveryArea',
            url: resolveComWixpressRestaurantsFulfillmentsV3FulfillmentMethodsUrl({
                protoPath: '/v3/fulfillment-methods/best-delivery-area',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __findBestDeliveryArea.fromReq = fromReq;
    __findBestDeliveryArea.__isAmbassador = true;
    return __findBestDeliveryArea;
}
//# sourceMappingURL=http.impl.js.map